import React from 'react';
import { css } from '@emotion/react';
import Box from '@mui/material/Box';
import { i18n_have_an_account } from '@yi/i18n/phrases/i18n_have_an_account';
import { i18n_sign_in } from '@yi/i18n/phrases/i18n_sign_in';

import { Bold } from '~/src/components/i18n/Bold';
import { useLocale } from '~/src/components/LocaleProvider';
import {
  CreateAccountForm,
  CreateAccountProvider,
} from '~/src/components/sign-up/CreateAccountForm';
import { breakpoints } from '~/src/styles/styled-mixins';

import { i18nPhrases } from './i18nPhrases';
import {
  BottomLeftText,
  BottomRightLinkText,
  MembershipText,
  ModalContentWrapper,
  ModalFooter,
  P,
} from '../AnonymousPaywall/elements';

const styles = {
  wrapper: css({
    // this modal is unique in terms of  spacing, so to adjust it we use this hack with negative margins
    marginBottom: '-25px',
    marginTop: '-25px',
    [breakpoints.minMobileLandscape]: {
      marginBottom: '0',
      marginTop: '0',
    },
  }),
};

type Props = {
  onClickSignIn?(): void;
};

export const FreeArticlePaywall: React.FC<Props> = ({ onClickSignIn }) => {
  const { locale } = useLocale();

  return (
    <div data-testid="anonymous-modal-paywall" css={styles.wrapper}>
      <ModalContentWrapper>
        <Box p={2}>
          <MembershipText>{i18nPhrases.loving_yoga_international_articles(locale)}</MembershipText>
          <p>
            {i18nPhrases.you_ve_reached_your_limit(locale, {
              transformFn: Bold,
            })}
          </p>
          <CreateAccountProvider>
            <CreateAccountForm shouldApproveReceiveEmails />
          </CreateAccountProvider>
          <P>{i18nPhrases.no_credit_card_required(locale)}</P>
        </Box>
        <ModalFooter>
          <BottomLeftText>{i18n_have_an_account(locale)}</BottomLeftText>
          <BottomRightLinkText
            data-testid="sign-in-button"
            href="javascript:void(0);"
            onClick={onClickSignIn}
          >
            {i18n_sign_in(locale)}
          </BottomRightLinkText>
        </ModalFooter>
      </ModalContentWrapper>
    </div>
  );
};
